// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvas-puzzle-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--tg-theme-secondary-bg-color, #efeff3);
  display: flex;
  flex-direction: column; /* Заголовок, Контейнер Доски, Канвас Трея */
  overflow: hidden;
  touch-action: none;
  z-index: 100;
}

.canvas-puzzle-container.debug {
  border: 3px solid red !important; /* Рамка всего контейнера */
}

/* Стили заголовка (без изменений) */
.puzzle-title {
  height: 40px;
  text-align: center;
  padding: 8px 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--tg-theme-text-color, #000000);
  background-color: var(--tg-theme-bg-color, #ffffff);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 5;
  flex-shrink: 0; /* Не сжимать */
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 50px;
  padding-right: 15px;
  position: relative;
  box-sizing: border-box;
}

/* Кнопка темы (без изменений) */
.theme-toggle-button {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--tg-theme-text-color, #000000);
  z-index: 6;
}

.theme-toggle-button:hover {
  transform: translateY(-50%) scale(1.1);
}

.theme-toggle-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* --- Общие стили для канвасов --- */
.puzzle-board,
.puzzle-tray {
  display: block;
  width: 100%; /* Трей на всю ширину */
  outline: none;
  flex-shrink: 0;
}

/* --- Специфичные стили для канваса ДОСКИ --- */
.puzzle-board {
  width: auto; /* Убираем 100%, чтобы размер определялся атрибутами/style */
  position: relative;
  box-shadow: 0 0 10px #00000062;
  z-index: 2; /* Должен быть над своим контейнером */
}

.puzzle-board.debug {
  border: 2px solid limegreen !important; /* Рамка самого канваса */
  outline: 2px solid orange !important; /* Еще одна рамка для верности */
  box-shadow: 0 0 0 3px yellow !important; /* И тень */
}

/* --- Контейнер для канваса доски --- */
.puzzle-board-container {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden; /* Важно для зума/пана в будущем */
  box-sizing: border-box;
  z-index: 1; /* Убедись, что он ниже возможных оверлеев */
}

.puzzle-board-container.debug {
  border: 2px dashed blue !important; /* Рамка контейнера доски */
}

.puzzle-tray-container {
  position: fixed; /* Для z-index */
  border-top: 1px solid #88888833;
  z-index: 3; /* По идее, выше доски, но ниже оверлеев */

  overflow-y: auto;
  touch-action: pan-y;
  /* Для плавной прокрутки на мобильных */
  -webkit-overflow-scrolling: touch;
}

.puzzle-tray-container.debug {
  outline: 2px dashed purple !important; /* Рамка контейнера трея */
  background-color: rgba(128, 0, 128, 0.05) !important; /* Легкий фон */
}
`, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/CanvasPuzzleBoard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,sBAAsB,EAAE,4CAA4C;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC,EAAE,2BAA2B;AAC/D;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,mDAAmD;EACnD,wCAAwC;EACxC,UAAU;EACV,cAAc,EAAE,eAAe;EAC/B,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;;EAEE,cAAc;EACd,WAAW,EAAE,uBAAuB;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,WAAW,EAAE,4DAA4D;EACzE,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU,EAAE,sCAAsC;AACpD;;AAEA;EACE,sCAAsC,EAAE,yBAAyB;EACjE,oCAAoC,EAAE,gCAAgC;EACtE,uCAAuC,EAAE,WAAW;AACtD;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAE,kCAAkC;EACpD,sBAAsB;EACtB,UAAU,EAAE,4CAA4C;AAC1D;;AAEA;EACE,kCAAkC,EAAE,2BAA2B;AACjE;;AAEA;EACE,eAAe,EAAE,gBAAgB;EACjC,+BAA+B;EAC/B,UAAU,EAAE,0CAA0C;;EAEtD,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC,EAAE,0BAA0B;EACjE,oDAAoD,EAAE,eAAe;AACvE","sourcesContent":[".canvas-puzzle-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: var(--tg-theme-secondary-bg-color, #efeff3);\r\n  display: flex;\r\n  flex-direction: column; /* Заголовок, Контейнер Доски, Канвас Трея */\r\n  overflow: hidden;\r\n  touch-action: none;\r\n  z-index: 100;\r\n}\r\n\r\n.canvas-puzzle-container.debug {\r\n  border: 3px solid red !important; /* Рамка всего контейнера */\r\n}\r\n\r\n/* Стили заголовка (без изменений) */\r\n.puzzle-title {\r\n  height: 40px;\r\n  text-align: center;\r\n  padding: 8px 0;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: var(--tg-theme-text-color, #000000);\r\n  background-color: var(--tg-theme-bg-color, #ffffff);\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  z-index: 5;\r\n  flex-shrink: 0; /* Не сжимать */\r\n  user-select: none;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding-left: 50px;\r\n  padding-right: 15px;\r\n  position: relative;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Кнопка темы (без изменений) */\r\n.theme-toggle-button {\r\n  position: absolute;\r\n  left: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  color: var(--tg-theme-text-color, #000000);\r\n  z-index: 6;\r\n}\r\n\r\n.theme-toggle-button:hover {\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n.theme-toggle-button:active {\r\n  transform: translateY(-50%) scale(0.95);\r\n}\r\n\r\n/* --- Общие стили для канвасов --- */\r\n.puzzle-board,\r\n.puzzle-tray {\r\n  display: block;\r\n  width: 100%; /* Трей на всю ширину */\r\n  outline: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* --- Специфичные стили для канваса ДОСКИ --- */\r\n.puzzle-board {\r\n  width: auto; /* Убираем 100%, чтобы размер определялся атрибутами/style */\r\n  position: relative;\r\n  box-shadow: 0 0 10px #00000062;\r\n  z-index: 2; /* Должен быть над своим контейнером */\r\n}\r\n\r\n.puzzle-board.debug {\r\n  border: 2px solid limegreen !important; /* Рамка самого канваса */\r\n  outline: 2px solid orange !important; /* Еще одна рамка для верности */\r\n  box-shadow: 0 0 0 3px yellow !important; /* И тень */\r\n}\r\n\r\n/* --- Контейнер для канваса доски --- */\r\n.puzzle-board-container {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  overflow: hidden; /* Важно для зума/пана в будущем */\r\n  box-sizing: border-box;\r\n  z-index: 1; /* Убедись, что он ниже возможных оверлеев */\r\n}\r\n\r\n.puzzle-board-container.debug {\r\n  border: 2px dashed blue !important; /* Рамка контейнера доски */\r\n}\r\n\r\n.puzzle-tray-container {\r\n  position: fixed; /* Для z-index */\r\n  border-top: 1px solid #88888833;\r\n  z-index: 3; /* По идее, выше доски, но ниже оверлеев */\r\n\r\n  overflow-y: auto;\r\n  touch-action: pan-y;\r\n  /* Для плавной прокрутки на мобильных */\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.puzzle-tray-container.debug {\r\n  outline: 2px dashed purple !important; /* Рамка контейнера трея */\r\n  background-color: rgba(128, 0, 128, 0.05) !important; /* Легкий фон */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
